import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Spinner } from "@/components/bits";
import { Activity, ExternalLink, AlertTriangle } from "lucide-react";

export default function ContentHealth() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get("/content-health").then((r) => setData(r.data)).catch(() => setData({ connected: false, items: [] })).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl">
      <p className="text-xs font-mono uppercase tracking-widest text-blue-700">Advisory Only · No Auto-Changes</p>
      <h1 className="font-serif text-3xl font-bold text-slate-900 mt-1 mb-2">Content Health</h1>
      <p className="text-slate-500 mb-6">Freshness flags are advisory. We never auto-delete, redirect, unpublish or rewrite posts.</p>

      {loading && <Spinner label="Scanning posts for freshness…" />}
      {!loading && !data?.connected && (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-slate-500">Connect WordPress to run freshness advisory.</div>
      )}
      {!loading && data?.connected && data.items.length === 0 && (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-6 text-center text-emerald-700">No freshness issues detected in recent posts.</div>
      )}
      <div className="space-y-3">
        {(data?.items || []).map((it) => (
          <div key={it.post_id} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-slate-800">{it.title} <span className="font-mono text-xs text-slate-400">#{it.post_id}</span></div>
              <a href={it.url} target="_blank" rel="noreferrer" className="text-xs text-blue-600 hover:underline inline-flex items-center gap-1">Open <ExternalLink className="h-3 w-3" /></a>
            </div>
            <div className="mt-2 flex flex-wrap gap-2">
              {it.flags.map((f, i) => (
                <span key={`${f.code || f.label || f}-${i}`} className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs text-amber-800">
                  <AlertTriangle className="h-3.5 w-3.5" /> {f.detail}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
